import React from "react";

const Footer = () => {
  const handleFocus = (e) => {
    if (e.target.value === "Enter Your Email") {
      e.target.value = "";
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      e.target.value = "Enter Your Email";
    }
  };

  return (
    <div className="hiraola-footer_area bg-black">
      <div className="footer-top_area">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="footer-widgets_info">
                <div className="footer-widgets_logo">
                  <a href="/">
                    <img
                      width="50%"
                      src="/assets/images/menu/logo/redCarat-01.png"
                      alt="red-carat Footer Logo"
                    />
                  </a>
                </div>

                <div className="widget-short_desc ">
                  <p className="text-light">
                    We are a team of designers and developers that create high
                    quality HTML Template & Woocommerce, Shopify Theme.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="footer-widgets_area">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="footer-widgets_title">
                      <h6>Product</h6>
                    </div>
                    <div className="footer-widgets">
                      <ul>
                        <li>
                          <a href="/">Latest Designs</a>
                        </li>
                        <li>
                          <a href="/">All products</a>
                        </li>
                        <li>
                          <a href="/">All Categories</a>
                        </li>
                        <li>
                          <a href="/">All Type</a>
                        </li>
                        <li>
                          <a href="/">Traditional Jewelry</a>
                        </li>
                        <li>
                          <a href="/">Accessories</a>
                        </li>
                        <li>
                          <a href="/">Shop By Price</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-lg-5">
                    <div className="footer-widgets_info">
                      <div className="footer-widgets_title">
                        <h6>Customer Care</h6>
                      </div>
                      <div className="widgets-essential_stuff">
                        <div className="footer-widgets">
                          <ul>
                            <li>
                              <a href="/">Lifetime Warranty & Maintenance</a>
                            </li>
                            <li>
                              <a href="/">500+ 5-Star Google Review</a>
                            </li>
                            <li>
                              <a href="/">Shipping Policy</a>
                            </li>
                            <li>
                              <a href="/">Privacy Policy</a>
                            </li>
                            <li>
                              <a href="/">Refund/Privacy Policy</a>
                            </li>
                            <li>
                              <a href="/">Refund/Cancellation Policy</a>
                            </li>
                            <li>
                              <a href="/">Terms & Conditions</a>
                            </li>
                            <li>
                              <a href="/">FAQ's</a>
                            </li>
                            <li>
                              <a href="/">Contact</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="instagram-container footer-widgets_area">
                      <div className="footer-widgets_title">
                        <h6>Follow Us</h6>
                      </div>
                      <div className="widget-short_desc">
                        <p className="text-light">
                          Stay Connected with us and never miss a beat by
                          following us on
                        </p>
                      </div>
                      <div className="hiraola-social_link pt-1">
                        <ul>
                          <li className="facebook">
                            <a
                              href="https://www.facebook.com/"
                              target="_blank"
                              rel="noreferrer"
                              title="Facebook"
                            >
                              <i className="fab fa-facebook"></i>
                            </a>
                          </li>
                          <li className="twitter">
                            <a
                              href="https://twitter.com/"
                              target="_blank"
                              rel="noreferrer"
                              title="Twitter"
                            >
                              <i className="fab fa-twitter-square"></i>
                            </a>
                          </li>
                          <li className="google-plus">
                            <a
                              href="https://www.plus.google.com/discover"
                              target="_blank"
                              rel="noreferrer"
                              title="Google Plus"
                            >
                              <i className="fab fa-google-plus"></i>
                            </a>
                          </li>
                          <li className="instagram">
                            <a
                              href="https://rss.com/"
                              target="_blank"
                              rel="noreferrer"
                              title="Instagram"
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom_area">
        <div className="container">
          <div className="footer-bottom_nav">
            <div className="row">
              <div className="col-lg-12">
                <div className="payment">
                  <a href="/">
                    <img
                      src="assets/images/footer/payment/1.png"
                      alt="Hiraola Payment Method"
                    />
                  </a>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="copyright">
                  <span>
                    Copyright © 2026 <a href="/">Red-Carat jewelry</a>. All
                    rights reserved.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
